/* ============================================================================
   LAH — SELO "3 PERGUNTAS" NO CONVITE DO QUIZ
   Tema: Testes de implementacao (4.0)

   Acrescenta o selo e reorganiza o cabecalho do convite para o titulo e o selo
   ficarem na mesma linha.

   ============================================================================
   O OBSERVADOR AGORA SE DESLIGA
   ============================================================================
   Ele existia so para esperar o convite do quiz ser criado. Feito isso, nao ha
   mais nada a observar — mas a versao anterior seguia vivo pelo resto da
   visita, acordando a cada mutacao do configurador para concluir que nao ha
   nada a fazer.

   Pior: o proprio enfeitar() INSERE elementos dentro da area observada, o que
   dispara o observador de novo. A guarda no inicio impedia o trabalho
   repetido, mas nao impedia o ciclo de acordar.

   Num celular simples, esse tipo de trabalho invisivel disputa a linha
   principal justamente enquanto o Alpine monta a proxima etapa.

   ============================================================================
   TUDO DENTRO DE UM try/catch
   ============================================================================
   Este script apenas ENFEITA: se ele falhar, o convite do quiz continua
   funcionando, so que sem o selo. Um erro aqui nunca deve aparecer para o
   cliente nem interromper o carregamento da etapa — e, sem a protecao, uma
   excecao lancada de dentro de um observador vira erro nao tratado no console.

   POR QUE UM ARQUIVO A PARTE, E NAO DENTRO DE lah-quiz.js
   O markup do convite e montado la, e mexer nele significaria reescrever um
   arquivo de 20 KB por causa de um <span>.
   ============================================================================ */

(function () {
    'use strict';

    var TEXTO = '3 perguntas';
    var observer = null;

    function enfeitar() {
        try {
            var titulo = document.querySelector('.lah-quiz__toggle-title');
            if (!titulo || !titulo.parentNode) return false;

            /* Ja enfeitado: nada a fazer, mas o trabalho esta concluido. */
            if (titulo.parentNode.classList.contains('lah-quiz__toggle-head')) {
                return true;
            }

            /* O titulo e o subtitulo sao irmaos dentro de um <span>. Envolvemos
               apenas o titulo com o selo, para que o subtitulo continue
               abaixo. */
            var head = document.createElement('span');
            head.className = 'lah-quiz__toggle-head';

            titulo.parentNode.insertBefore(head, titulo);
            head.appendChild(titulo);

            var selo = document.createElement('span');
            selo.className = 'lah-quiz__selo';
            selo.textContent = TEXTO;
            head.appendChild(selo);

            return true;
        } catch (e) {
            /* Enfeite nao pode quebrar fluxo: desistimos em silencio. */
            return true;
        }
    }

    function tentar() {
        if (!enfeitar()) return;

        if (observer) {
            observer.disconnect();
            observer = null;
        }
    }

    tentar();

    /* O convite e criado pelo lah-quiz.js quando a etapa de campo de visao
       aparece, entao pode nao existir ainda no carregamento. */
    if (!document.querySelector('.lah-quiz__toggle-head') && window.MutationObserver) {
        var raiz = document.querySelector('.product-lens-select');

        if (raiz) {
            var pendente = false;

            observer = new MutationObserver(function () {
                if (pendente) return;
                pendente = true;

                requestAnimationFrame(function () {
                    pendente = false;
                    tentar();
                });
            });

            observer.observe(raiz, { childList: true, subtree: true });
        }
    }
})();
